import URL from '../api_url';

export const BEHAVIOR_API = `${URL}/behavior`;

export const BEHAVIORS_API = `${URL}/behaviors`;
